const STAFF_ROLES = new Set(['doctor', 'duty_doctor', 'admin', 'moderator', 'supervisor']);

export function canSeeDangerMarks(account) {
  if (!account || account.is_active === false || account.is_block === true) return false;
  const source = account.type_profile;
  const roles = Array.isArray(source) ? source
    : typeof source === 'string' ? source.split(',').map((role) => role.trim()) : [];
  return roles.some((role) => STAFF_ROLES.has(role));
}